import { useDraggable, useDroppable } from '@dnd-kit/core';
import { useState } from 'react';
import { Tooltip } from 'reactstrap';


// Componente Draggable
export const DraggableItem: React.FC<{ id: string; name: string }> = ({ id, name }) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({ id });

  const style = {
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
    cursor: 'grab',
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {name}
    </div>
  );
};

// Componente Droppable
export const DroppableArea: React.FC<{
  id: string; children: React.ReactNode;
  onSave?: () => void;
  isLoading?: boolean;
  selectedAttributesLength: number;
}> =
  ({ id, children, onSave, isLoading, selectedAttributesLength }) => {
    const { setNodeRef, isOver } = useDroppable({ id });
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

    const buttonId = 'save-cohort-btn';
    const style = {
      minHeight: '300px',
      border: '1px dashed #ccc',
      borderRadius: '0.6rem',
      backgroundColor: isOver ? '#f8f9fa' : 'white',
      padding: '1rem',
      marginTop: '1rem',

    };

    return (
      <div ref={setNodeRef} style={style}>
        <div className='text-center' style={{ fontSize: '1.1rem ', fontWeight: '700 ', color: '#000' }}>
          Arraste os Atributos aqui
        </div>
        <div className='text-center' style={{ fontSize: '0.835rem ', fontWeight: '300 ', color: '#000' }}>
          Construa combinações dinâmicas para criar seu cohort
        </div>

        {children}

        <div className="text-center mt-3">
          <button id={buttonId} className="cohort_create_button" onClick={onSave} disabled={isLoading || selectedAttributesLength < 3}>
            {isLoading ? 'Salvando...' : 'Salvar Cohort'}
          </button>
          {selectedAttributesLength < 3 && (
            <Tooltip
              placement="top"
              isOpen={tooltipOpen}
              target={buttonId}
              toggle={toggleTooltip}
            >
              Selecione pelo menos 3 atributos para salvar o cohort.
            </Tooltip>
          )}
        </div>
      </div>
    );
  };